/**
 * Formats a numeric value as a currency string with a specified sign.
 * * This function ensures the amount is treated as a number, handles null/undefined/non-numeric
 * values by defaulting to 0, and correctly places the negative sign outside the currency
 * symbol if the amount is negative. It formats the value to two decimal places.
 *
 * @param {string | number | null | undefined} val - The raw amount value. It can be a string, number, null, or undefined.
 * @param {string} selectedCurrencySign - The currency symbol (e.g., '$', '€', '₹').
 * @returns {string} The formatted currency string (e.g., "$1,234.56", "-€50.00").
 */
// export const getAmount = (val, selectedCurrencySign) => {
//     const amount = parseFloat(val || 0);
//     return `${amount < 0 ? '-' : ''}${selectedCurrencySign}${Math.abs(amount).toFixed(2)}`;
// };

export const getAmount = (val, selectedCurrencySign, options = {}) => {
    const { decimals = 2, indianFormat = true, showSymbol = true } = options;
    
    const amount = parseFloat(val || 0);
    const isNegative = amount < 0;
    const absAmount = Math.abs(amount);
    
    // Format with specified decimal places
    const formattedAmount = absAmount.toFixed(decimals);
    const parts = formattedAmount.split('.');
    let integerPart = parts[0];
    const decimalPart = parts[1];
    
    let formattedInteger;
    
    if (indianFormat) {
        // Indian numbering system (lakhs, crores)
        let lastThree = integerPart.slice(-3);
        let otherNumbers = integerPart.slice(0, -3);
        
        if (otherNumbers !== '') {
            lastThree = ',' + lastThree;
        }
        
        formattedInteger = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
    } else {
        // International numbering system (thousands)
        formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    
    const formattedAmountWithCommas = decimalPart !== undefined && decimalPart !== ''
        ? `${formattedInteger}.${decimalPart}`
        : formattedInteger;
    
    const sign = showSymbol ? selectedCurrencySign : '';
    const negativeSign = isNegative ? '-' : '';
    
    // Handle cases where decimals should be removed if they're .00
    if (decimals === 0) {
        return `${negativeSign}${sign}${formattedInteger}`;
    }
    
    return `${negativeSign}${sign}${formattedAmountWithCommas}`;
};